import Vue from 'vue'
import Router from 'vue-router'


/*
* @ all pages
*
*/

import Home from '@/pages/Home'
import ResultOfRecommendation from '@/pages/ResultOfRecommendation'
import Viewer from '@/pages/Viewer'

Vue.use(Router)
const router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
      },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'コレヨモ！ - 読後の感情を認識するマンガ人工知能『MAI』が、あなたの読みたいマンガをおすすめします。',
        metaTags: [
          {
            name: 'description',
            content: 'コレヨモ！は、マンガ人工知能MAIが読者の感情を10次元で認識して、今の気持ちに合いそうな作品をおすすめします。'
          }
        ]
      }
    },
    {
      path: '/recommend',
      name: 'ResultOfRecommendation',
      component: ResultOfRecommendation,
      meta: {
        title: 'コレヨモ！ - {傾向分析キャッチコピー}さんへのおすすめマンガ',
        metaTags: [
          {
            name: 'description',
            content: 'コレヨモ！は、マンガ人工知能MAIが読者の感情を10次元で認識して、今の気持ちに合いそうな作品をおすすめします。'
          }
        ]
      }
    },
    {
      path: '/viewer/:workCode/:storyId',
      name: 'Viewer',
      component: Viewer,
      meta: {
        title: 'コレヨモ！ - {傾向分析キャッチコピー}さんへのおすすめマンガ',
        metaTags: [
          {
            name: 'description',
            content: 'コレヨモ！は、マンガ人工知能MAIが読者の感情を10次元で認識して、今の気持ちに合いそうな作品をおすすめします。'
          }
        ]
      }
      
    },
  ],
  mode: "history",
  base: process.env.ROOT_URL
});


router.afterEach((to) => {
  document.title = to.meta.title;
  $('body').css({'overflow':'','position':''});
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js